import { atom, useAtom } from 'jotai';

export const envNameAtom = atom('');

export function useEnvNameAtom() {
  return useAtom(envNameAtom);
}
